/**
 *
 * Asynchronously loads the UnsubscribeModal component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
